import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { createPostageUser, fetchUserDetailsByNetId } from '../services/api';

function Login() {
    const { user, login, logout } = useUser();
    const [netId, setNetId] = useState('');
    const [isNewUser, setIsNewUser] = useState(false);
    const [newUserDetails, setNewUserDetails] = useState({
        netId: '',
        firstName: '',
        lastName: '',
        department: '',
        boxNumber: '',
        phone: ''
    });
    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            const userResponse = await fetchUserDetailsByNetId(netId);
            login(userResponse);
        } catch (error) {
            console.error("Error fetching user details:", error);
            setIsNewUser(true);
            setNewUserDetails(prev => ({ ...prev, netId }));
        }
    };

    const handleCreateUser = async () => {
        try {
            await createPostageUser(newUserDetails);
            const newUser = await fetchUserDetailsByNetId(newUserDetails.netId);
            login(newUser);
        } catch (error) {
            console.error("Error creating new user:", error);
        }
    };

    const handleProceed = () => {
        navigate(`/user/${user.netId}`);
    };

    if (user) {
        return (
            <div className="container">
                <div className='page-header'>
                    <h1 className='gradient-under'>Welcome, {user.netId}@uw.edu</h1>
                </div>
                <button onClick={handleProceed} className="btn btn-primary me-3">Go to My Profile</button>
                <button onClick={logout} className='btn btn-danger me-3'>Log Out</button>
            </div>
        );
    }

    return (
        <div className="container">
            <div className='page-header'>
                <h1 className='gradient-under'>Login</h1>
            </div>
            <p>This first step is a placeholder and the netId will be obtained by Shibboleth. Details on the following step will use IdP values as the default, while allowing end-user to override them.</p>
            {!isNewUser ? (
                <div className='input-group'>
                    <input value={netId} onChange={e => setNetId(e.target.value)} placeholder="Enter NetId" className='form-control' />
                    <button className='btn btn-success me-3' onClick={handleLogin}>Login</button>
                </div>
            ) : (
                <>
                    <div className="mb-3">
                        <label htmlFor="netId" className="form-label">NetId</label>
                        <input type="text" className="form-control" id="netId" name="netId" value={newUserDetails.netId} readOnly />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="firstName" className="form-label">First Name</label>
                        <input type="text" className="form-control" id="firstName" name="firstName" value={newUserDetails.firstName} onChange={e => setNewUserDetails({ ...newUserDetails, firstName: e.target.value })} placeholder="First Name" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="lastName" className="form-label">Last Name</label>
                        <input type="text" className="form-control" id="lastName" name="lastName" value={newUserDetails.lastName} onChange={e => setNewUserDetails({ ...newUserDetails, lastName: e.target.value })} placeholder="Last Name" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="department" className="form-label">Department</label>
                        <input type="text" className="form-control" id="department" name="department" value={newUserDetails.department} onChange={e => setNewUserDetails({ ...newUserDetails, department: e.target.value })} placeholder="Department" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="boxNumber" className="form-label">Box Number</label>
                        <input type="text" className="form-control" id="boxNumber" name="boxNumber" value={newUserDetails.boxNumber} onChange={e => setNewUserDetails({ ...newUserDetails, boxNumber: e.target.value })} placeholder="Box Number" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="phone" className="form-label">Phone <em>(10-digit numbers only, no symbols)</em></label>
                        <input type="tel" className="form-control" id="phone" name="phone" pattern="[0-9]{10}" value={newUserDetails.phone} onChange={e => setNewUserDetails({ ...newUserDetails, phone: e.target.value })} placeholder="Phone" />
                    </div>
                    <button onClick={handleCreateUser} className='btn btn-success'>Create User</button>
                </>
            )}
        </div>
    );
}

export default Login;
